import ToggleConfig from '../../../config/ToggleConfig';
import { ConnectionRecord } from '../../../webrtc/agent/interfaces';
import DataReportBlock from '../../../reporter/report/DataReportBlock';

function filterConnection(record: ConnectionRecord, toggle: ToggleConfig) {
  if (toggle.internalIp) {
    return record;
  }
  const copy = { ...record };

  const conn = copy.connection;
  if (conn.dest && !toggle.internalIp) {
    delete conn.dest.intIp;
  }
  if (conn.source && !toggle.internalIp) {
    delete conn.source.intIp;
  }
  return copy;
}

export default function filterConnections(
  report: DataReportBlock<ConnectionRecord>,
  toggle: ToggleConfig
): DataReportBlock<ConnectionRecord> {
  const data = report.data.map(d => filterConnection(d, toggle));
  return new DataReportBlock({ data });
}
